let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d9tFv")).then(() => parcelRequire('4opkK'));